var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImgIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.5 1.5)",
  stroke: "#7C7C7C",
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 18H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 8c-4.5-.917-8.625 8-11.7 8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 11s3.338-2.75 9.45 3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 5,
  r: 2
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImgIcon);
export default ForwardRef;